<!--在线监管-净化器清洗管理-->
<template>
  <section>
    <!-- 工具条 -->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filter" size="mini">
        <el-form-item>
          <el-cascader
            placeholder="所属单位"
            @change="handleFilterChange"
            v-model="filter.owner"
            :options="customerTree"
            :props="customerProps"
            clearable
            filterable
          />
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 200px;"
            placeholder="清洗周期"
            @change="handleFilterChange"
            v-model="filter.filter_wash_day"
            clearable
            filterable
          >
            <el-option value="30" label="30"/>
            <el-option value="60" label="60"/>
            <el-option value="90" label="90"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 200px;"
            placeholder="清洗状态"
            @change="handleFilterChange"
            v-model="filter.status"
            clearable
            filterable
          >
            <el-option value="4" label="橙"/>
            <el-option value="3" label="红"/>
            <el-option value="2" label="黄"/>
            <el-option value="1" label="绿"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="filter.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00','23:59:59']"
            @change="handleFilterChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="washRecorder">清洗记录</el-button>
          <el-button type="primary" @click="runVerifyRecorder">运行核查记录</el-button>
          <el-button type="primary" @click="openExportSizeInput">导出</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!-- 列表 -->
    <el-col :span="24">
      <el-table
        :data="datalist.content"
        size="mini"
        border
        highlight-current-row
        v-loading="loading"
        @selection-change="selsChange"
        :max-height="clientHeight"
        style="width: 100%"
        :key="itemKey"
        @sort-change="handleSortChange"
        :default-sort=defaultSort
      >
        <el-table-column type="selection" :selectable="canSelectRow"/>
        <el-table-column type="index" label="#" align="center" width="55"/>
        <el-table-column
          prop="name"
          label="监测点"
          width="140"
          show-overflow-tooltip
          header-align="center"
        >
        </el-table-column>
        <el-table-column
          prop="owner_name"
          width="160"
          label="所属单位"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          prop="addr"
          width="140"
          label="地址"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          prop="cuisine"
          width="140"
          label="餐饮企业类型"
          show-overflow-tooltip
          header-align="center"
          align="center"
        />
        <el-table-column
          prop="stove_num"
          label="灶头数"
          width="90"
          align="center"
          header-align="center"
          sortable
        />
        <el-table-column
          prop="filter_wash_day"
          label="清洗周期"
          width="140"
          align="center"
          header-align="center"
          sortable
        />
        <el-table-column
          prop="create_at"
          label="上次清洗日期"
          width="160"
          align="center"
          header-align="center"
          sortable
        >

          <template slot-scope="scope">
            <template v-if="scope.row.wash_number == 0">-</template>
            <template v-else>{{ scope.row.create_at }}</template>
          </template>
        </el-table-column>
        <el-table-column
          prop="un_wash_day"
          label="累计未清洗天数"
          width="140"
          align="center"
          header-align="center"
          sortable
        />
        <el-table-column
          prop="wash_over_day"
          label="超时天数"
          width="106"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <template v-if="scope.row.wash_over_day <= 0">0</template>
            <template v-else>{{ scope.row.wash_over_day }}</template>
          </template>
        </el-table-column>
        <el-table-column
          prop="wash_number"
          label="清洗次数"
          align="center"
          width="140"
          header-align="center"
          sortable
        />
        <el-table-column
          prop="handle_time"
          label="最近一次核查日期"
          align="center"
          width="140"
          header-align="center"
        />
        <el-table-column
          prop="pur_current"
          label="净化器电流值"
          align="center"
          width="140"
          header-align="center"
        />
        <el-table-column
          prop="question"
          label="存在问题"
          align="center"
          width="140"
          header-align="center"
        />
        <el-table-column
          prop="handle_suggestion"
          label="整改建议"
          align="center"
          width="140"
          header-align="center"
        />
        <el-table-column
          prop="filter_status_info"
          width="100"
          label="净化器状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
          fixed="right"
        />
        <el-table-column
          label="清洗状态"
          prop="status"
          align="center"
          header-align="center"
          width="100"
          sortable
          fixed="right"
        >
          <template slot-scope="scope">
            <img height="40" width="40" :src="getImg(scope.row.color)" alt="清洗状态"/>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="180"
          fixed="right"
          header-align="center"
        >
          <template slot-scope="scope">
            <img
              title="清洗台账"
              @click="openWashAccountBook(scope.row)"
              src="../../src/asset/img/清洗台账.png"
              alt="清洗台账"
              class="opt"
              style="width: 18px; height: 18px; color: #3691fb; cursor: pointer;margin-right: 10px"
            />
            <img
              title="报警消息"
              @click="openFillterNotWash(scope.row)"
              src="../../src/asset/img/报警消息.png"
              alt="报警消息"
              class="opt"
              style="width: 20px; height: 20px; color: #3691fb; cursor: pointer;margin-right: 10px"
            />
            <img
              title="报警事件"
              @click="openPoliceEvent(scope.row)"
              src="../../src/asset/img/报警事件.png"
              alt="报警事件"
              class="opt"
              style="width: 18px; height: 18px; color: #3691fb; cursor: pointer;margin-right: 10px"
            />
            <img
              title="清洗上传"
              @click="openAddWash(scope.row)"
              src="../../src/asset/img/清洗上传.png"
              alt="清洗上传"
              class="opt"
              style="width: 19px; height: 19px; color: #3691fb; cursor: pointer;margin-right: 10px"
            />
            <img
              title="运行核查记录"
              @click="openOnePointRunVerifyRecorder(scope.row.id)"
              src="../../src/asset/img/运行核查.png"
              alt="运行核查记录"
              class="opt"
              style="width: 19px; height: 19px; color: #3691fb; cursor: pointer;margin-right: 10px;"
            />
            <!--            <i-->
            <!--              title="清洗台账"-->
            <!--              @click="openWashAccountBook(scope.row)"-->
            <!--              class="opt el-icon-notebook-2"-->
            <!--              style="color: #3691fb"-->
            <!--            />-->

            <!--            <i-->
            <!--              title="报警消息"-->
            <!--              @click="openFillterNotWash(scope.row)"-->
            <!--              class="opt el-icon-sunrise-1"-->
            <!--              style="color: #3691fb"-->
            <!--            />-->
            <!--            <i-->
            <!--              title="报警事件"-->
            <!--              @click="openPoliceEvent(scope.row)"-->
            <!--              class="opt el-icon-document"-->
            <!--              style="color: #3691fb"-->
            <!--            />-->
          </template>
        </el-table-column>
      </el-table>
    </el-col>

    <!-- 工具条 -->
    <el-col :span="24" class="toolbar">
      <el-button
        type="primary"
        size="mini"
        @click="batchSendMessage"
        :disabled="sels.length === 0"
      >发送短信
      </el-button
      >
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filter.page"
        :page-sizes="filter.pageSizes"
        layout="total, sizes, prev, pager, next, jumper"
        :total="datalist.total"
        style="display: inline-block; margin-left: 15px"
      >
      </el-pagination>
    </el-col>

    <!--    油烟净化设备运行情况现场核查记录dialog（开始    title="油烟净化设备运行情况现场核查记录"-->
    <el-dialog
      :visible.sync="isShowRunVerifyRecorder"
      :center="true"
      width="60%"
      style="position: fixed !important;
      top: 57% ;
      left: 50%;
      width: 120%;
      height: 140%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translate(-50%, -50%) !important;
      z-index: 999 !important;">
      <h1 style="text-align: center;color: black;margin-top: -30px">油烟净化设备运行情况现场核查记录</h1>
      <div style="text-align: left">
        <el-col :span="24" >
          <el-form :inline="true" :model="filterCheck" size="mini">
            <el-form-item>
              <el-cascader
                placeholder="所属单位"
                v-model="filterCheck.owner"
                :options="customerTree"
                :props="customerProps"
                @change="goSerachRunVerify"
                clearable
                filterable
              />
            </el-form-item>
            <el-form-item>
              <el-select
                @change="goSerachRunVerify"
                v-model="filterCheck.user_id"
                filterable
                remote
                reserve-keyword
                placeholder="请输入提交人名称"
                :remote-method="remoteFilterMethod"
                style="width: 70%"
              clearable>
                <el-option
                  v-for="item in userList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                type="daterange"
                v-model="filterCheck.dateRange"
                @change="goSerachRunVerify"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="goSerachRunVerify">查询</el-button>
              <el-button type="primary" @click="openAddRunVerify">新增</el-button>
              <el-button type="primary" @click="ExportSerachRunVerify">导出</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>

      <!--        <div style="max-height: calc(100vh - 300px);overflow-y: auto;">-->

      <el-table
        :data="filterWashList.list"
        size="mini"
        border
        highlight-current-row
        v-loading="loading"
        :max-height="clientHeight"
        style="width: auto;height: auto"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="55"
        />
        <el-table-column
          prop="locale_name"
          label="监测点"
          width="180"
          align="center"
          header-align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="locale_addr"
          label="安装地址"
          width="180"
          align="center"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          prop="handle_at"
          label="核查日期"
          width="180"
          align="center"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          prop="handle_name"
          label="核查人"
          width="180"
          align="center"
          show-overflow-tooltip
          header-align="center"
        >
        </el-table-column>

        <el-table-column
          prop="filter_status_info"
          label="净化器状态"
          align="center"
          width="180"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          prop="question"
          label="问题清单"
          align="center"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          prop="other"
          label="其他"
          align="center"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          prop="handle_suggestion"
          label="建议"
          align="center"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          label="操作"
          align="center"
          width="100"
          fixed="right"
          header-align="center"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="deleteWashFilterInfo(row)" size="mini">删除</el-button>
            <el-button type="text" @click="openLookFilterInfo(row)" size="mini">查看</el-button>
          </template>
        </el-table-column>

      </el-table>


      <div style="text-align: left;max-height: calc(100vh - 300px);margin-top:20px;">
       <el-pagination
          small
          background
          @size-change="handleFilterCheckSizeChange"
          @current-change="handleFilterCheckCurrentChange"
          :current-page.sync="filterCheck.page"
          :page-sizes="filterCheck.pageSizes"
          layout="total, sizes, prev, pager, next, jumper"
          :total="filterWashList.count"
          style="display: inline-block; margin-left: 15px"
        >
        </el-pagination>
      </div>


    </el-dialog>
    <!--    油烟净化设备运行情况现场核查记录dialog（结束-->

    <!--    新增现场核查记录dialog（开始-->
    <el-dialog
      :title="addRunVerifyTitle"
      :visible.sync="addRunVerify"
      width="50%"
      style="position: fixed !important;
      top: 47% ;
      bottom: 50%;
      left: 50%;
      width: 120%;
      height: 120%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translate(-50%, -50%) !important;
      z-index: 999 !important;">
      <div style="max-height: calc(100vh - 200px);overflow-y: auto;">
        <el-form :model="addRunVerifyRuleForm" :rules="runVerifyRules" ref="addRunVerifyRuleForm" size="mini" label-width="100px" class="demo-ruleForm" :disabled="addRunVerifyTitle === '查看'">
          <el-form-item prop="LocaleId" label="监测点">
            <template>
              <template v-if="addRunVerifyTitle == '查看'">
                <el-input
                  placeholder="请输入监测点名称"
                  v-model="addRunVerifyRuleForm.LocaleName"
                  :disabled="true"
                style="width: 70%">
                </el-input>
              </template>
              <template v-else>
                <el-select
                  v-model="addRunVerifyRuleForm.LocaleId"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入监测点名称"
                  :remote-method="remoteMethod"
                  style="width: 70%">
                  <el-option
                    v-for="item in localeList"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </template>
            </template>
          </el-form-item>
          <el-form-item label="问题来源" prop="questionSource">
            <el-select v-model="addRunVerifyRuleForm.questionSource" placeholder="请选择问题来源" style="width: 30%">
              <el-option label="红码核查" :value="1"></el-option>
              <el-option label="日常排查" :value="2"></el-option>
              <el-option label="上级督办" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="点位类型" prop="pointType">
            <el-select v-model="addRunVerifyRuleForm.pointType" placeholder="请选择点位类型" style="width: 30%" @change="changePointType">
              <el-option label="在线监测" :value="1"></el-option>
              <el-option label="在线监控" :value="2"></el-option>
              <el-option label="其他单位设备" :value="3"></el-option>
              <el-option label="非监测监控类" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="核查日期" required prop="verifyDay">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="addRunVerifyRuleForm.verifyDay"
              type="date"
              placeholder="请选择核查日期"
              style="width: 30%">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="净化器情况" prop="purifierSituation">
            <div style="display: flex; align-items: center; gap: 10px;">
              <el-input
                v-if="!addRunVerifyRuleForm.cannotDetect"
                v-model="addRunVerifyRuleForm.purifierSituation"
                placeholder="工作电流 A"
                style="width: 30%">
              </el-input>
              <el-checkbox v-model="addRunVerifyRuleForm.cannotDetect" @change="changeDetect">无法检测</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item label="净化器状态" prop="purifierStatus">
            <div style="display: flex; align-items: center; gap: 10px;">
              <el-select v-model="addRunVerifyRuleForm.purifierStatus" placeholder="请选择净化器状态" style="width: 28%">
                <el-option label="开启" :value="1"></el-option>
                <el-option label="异常" :value="2"></el-option>
                <el-option label="失效" :value="3"></el-option>
                <el-option label="关闭" :value="4"></el-option>
                <el-option label="闲置" :value="5"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="净化器净化率" prop="filterRate">
            <template>
              <el-input
                  placeholder="请输入净化器净化率"
                  v-model="addRunVerifyRuleForm.filterRate"
                  :disabled="addRunVerifyTitle == '查看'"
                  style="width: 30%">
                  <i slot="suffix" style="margin-right: 10px;">%</i>
                </el-input>
            </template>
          </el-form-item>

          <el-form-item label="问题清单" prop="questionList">
            <el-checkbox-group v-model="addRunVerifyRuleForm.questionList">
              <div style="margin-bottom: 5px;">
                <el-checkbox label="未安装油烟净化设施">未安装油烟净化设施</el-checkbox>
              </div>
              <div style="margin-bottom: 5px;">
                <el-checkbox label="无清洗检修平台">无清洗检修平台</el-checkbox>
              </div>
              <div style="margin-bottom: 5px;">
                <el-checkbox label="不正常使用净化设施">不正常使用净化设施</el-checkbox>
              </div>
              <div style="display: flex; align-items: center; margin-top: 5px;">
                <el-checkbox label="其他">其他</el-checkbox>
                <el-input
                  v-model="addRunVerifyRuleForm.otherQuestion"
                  placeholder="如有其他问题请输入"
                  style="width: 40%; margin-left: 10px;"
                  :disabled="!addRunVerifyRuleForm.questionList.includes('其他')">
                </el-input>
              </div>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="monitorLabel" prop="monitorWay">
            <el-select v-model="addRunVerifyRuleForm.monitorWay" :placeholder="'请选择' + monitorLabel" style="width: 30%">
              <el-option label="正常" value="正常"></el-option>
              <el-option label="不正常" value="不正常"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="monitorDataLabel" prop="monitorDataStatus">
            <el-cascader
              v-model="addRunVerifyRuleForm.monitorDataStatus"
              :options="cascaderOptions"
              :placeholder="'请选择' + monitorDataLabel"
              clearable    style="width: 30%">
            </el-cascader>
          </el-form-item>
          <el-form-item label="整改建议" prop="rectifyAdvice">
            <el-cascader
              v-model="addRunVerifyRuleForm.rectifyAdvice"
              :options="rectifyAdviceOptions"
              :props="cascaderProps"
              placeholder="请选择整改建议"
              clearable
              style="width: 30%"></el-cascader>
          </el-form-item>
          <el-form-item label="其他建议">
            <el-input
              type="textarea"
              v-model="addRunVerifyRuleForm.otherAdvice"
              placeholder="如有其他建议请输入"
              :rows="3"
            style="width: 70%">
            </el-input>
          </el-form-item>
          <el-form-item label="现场照片" prop="sitePic" style="position: relative;">
            <div v-if="addRunVerifyTitle === '查看'">
              <div class="img-list" v-if="fileListInfo">
                <div class="single-img" v-for="(item, idx) in fileListInfo" :key="idx"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item"
                    fit="fit"
                    :preview-src-list="fileListInfo"/>
                </div>
              </div>
            </div>
            <div v-else>
              <div style="position: absolute;left: -100px;top: 30px;width: 100px;font-size:10px;">(净化器照片、工作电流照片、现场核查照片)(1-5张)</div>
<!--              <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>-->
              <el-upload
                ref="uploadSitePic"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png"
                :action="uploadSitePic()"
                :on-success="(res, file) => handleSitePicSuccess(res, file)"
                :limit="5"
                :file-list="addRunVerifyRuleForm.sitePic"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url" alt=""
                  >
                  <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="handleSitePicRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
                </div>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addRunVerify = false">取 消</el-button>
        <el-button type="primary" @click="configAddRunVerify" v-if="addRunVerifyTitle !== '查看'">提 交</el-button>
      </div>
    </el-dialog>

    <!--    净化器清洗报警事件处理记录dialog（开始    title="净化器清洗报警事件处理记录"-->
    <el-dialog

      :visible.sync="filterWashRecorder"
      :center="true"
      width="60%"
      style="position: fixed !important;
      top: 57% ;
      left: 50%;
      width: 120%;
      height: 140%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translate(-50%, -50%) !important;
      z-index: 999 !important;">
      <h1 style="text-align: center;color: black;margin-top: -30px">油烟净化设备清洗台账上传记录</h1>
      <div style="text-align: left">
        <el-col :span="24" >
          <el-form :inline="true" :model="filterWash" size="mini">
            <el-form-item>
              <el-cascader
                placeholder="所属单位"
                v-model="filterWash.owner"
                :options="customerTree"
                :props="customerProps"
                @change="goSerachWash"
                clearable
                filterable
              />
            </el-form-item>
            <el-form-item>
              <el-select
                style="width: 200px;"
                placeholder="清洗方式"
                v-model="filterWash.UpwashWay"
                clearable
                @change="goSerachWash"
                filterable
              >
                <el-option value="Complaint" label="自主清洗"/>
                <el-option value="FilterWash" label="第三方清洗"/>
                <el-option value="BusinessStopped" label="净化器换新"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                type="daterange"
                v-model="filterWash.dateRange"
                @change="goSerachWash"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="goSerachWash">查询</el-button>
              <el-button type="primary" @click="openAddWash('')">新增</el-button>
              <el-button type="primary" @click="ExportWashRecorder">导出</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>

      <!--        <div style="max-height: calc(100vh - 300px);overflow-y: auto;">-->

      <el-table
        :data="filterWashData.content"
        size="mini"
        border
        highlight-current-row
        v-loading="loading"
        :max-height="clientHeight"
        style="width: auto;height: auto"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="55"
        />
        <el-table-column
          prop="LocaleName"
          label="监测点"
          width="180"
          align="center"
          header-align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="LocaleAddr"
          label="安装地址"
          width="180"
          align="center"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          prop="CreatedAt"
          label="提交时间"
          width="180"
          align="center"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          label="清洗日期"
          width="180"
          align="center"
          show-overflow-tooltip
          header-align="center"
        > <template slot-scope="{ row }">
          <span>{{ row.EndDate.split(' ')[0] }}</span>
        </template>
        </el-table-column>
        <el-table-column
          label="清洗方式"
          align="center"
          header-align="center"
          width="180"
        >
          <template slot-scope="{ row }">
            <span>{{ row.UploadType | typeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Remark"
          label="备注"
          align="center"
          show-overflow-tooltip
          header-align="center"
        />
        <el-table-column
          label="操作"
          align="center"
          width="100"
          fixed="right"
          header-align="center"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="deleteWashInfo(row)" size="mini">删除</el-button>
            <el-button type="text" @click="openLookAddWashDialog(row)" size="mini">查看</el-button>
          </template>
        </el-table-column>

      </el-table>
      <!--        </div>-->

      <div style="text-align: left;max-height: calc(100vh - 300px);">
        <el-pagination
          @size-change="(v) => handlePageChange(v, 'Size')"
          @current-change="(v) => handlePageChange(v, 'PageCurrent')"
          :current-page="paginationData.currentPage"
          :page-sizes="paginationData.PageCurrent"
          :page-size="paginationData.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="filterWashData.total">
        </el-pagination>
      </div>


    </el-dialog>

    <!--    净化器清洗报警事件处理记录dialog（结束-->


    <!--    净化器清洗记录新增dialog（开始-->
    <el-dialog
      :title="washRecorderTitle"
      :visible.sync="addWashDialog"
      width="50%"
      style="position: fixed !important;
      top: 47% ;
      bottom: 50%;
      left: 50%;
      width: 120%;
      height: 120%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translate(-50%, -50%) !important;
      z-index: 999 !important;">
      <div style="max-height: calc(100vh - 200px);overflow-y: auto;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" size="mini" label-width="100px" class="demo-ruleForm" :disabled="washRecorderTitle === '查看'">
          <el-form-item prop="LocaleId" label="监测点">
<!--            此时是从清洗记录里面上传-->
            <template v-if="filterWashRecorder">
              <template v-if="washRecorderTitle == '查看'">
                <el-input
                  placeholder="请输入监测点名称"
                  v-model="ruleForm.point"
                  :disabled="true">
                </el-input>
              </template>
              <template v-else>
                <el-select
                  v-model="ruleForm.LocaleId"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入监测点名称"
                  :remote-method="remoteMethod">
                  <el-option
                    v-for="item in localeList"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </template>
            </template>
<!--            此时是直接在主页上传-->
            <template v-else>
              <el-input
                placeholder="请输入监测点名称"
                v-model="ruleForm.point"
                :disabled="true">
              </el-input>
            </template>
          </el-form-item>
          <el-form-item label="类型" prop="washWay">
            <el-select v-model="ruleForm.washWay" placeholder="请选择清洗类型" @change="changeWashWay">
              <el-option label="第三方清洗" value="FilterWash"></el-option>
              <el-option label="自主清洗" value="Complaint"></el-option>
              <el-option label="净化器换新" value="BusinessStopped"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="清洗日期" required>
            <el-col :span="11">
              <el-form-item prop="starDay">
                <el-date-picker
                  v-model="ruleForm.starDay"
                  type="date"
                  placeholder="选择日期"
                  style="width: 205px">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <div v-if="ruleForm.washWay === 'FilterWash'">
            <el-form-item label="清洗单位" prop="washUnit">
              <el-input v-model="ruleForm.washUnit" placeholder="请输入清洗单位"></el-input>
            </el-form-item>
            <el-form-item label="清洗前照片" prop="washPer" style="position: relative;height: auto">
              <div v-if="washRecorderTitle === '查看'">
                <div class="img-list" v-if="fileListInfo">
                  <div class="single-img" v-for="(item, idx) in fileListInfo" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListInfo"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashPerThird"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="upload()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washPer')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="removeImg(file, 'washPer')">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="清洗后照片" prop="washBack" style="position: relative;height: auto">
              <div v-if="washRecorderTitle === '查看'">
                <div class="img-list" v-if="fileListBefore">
                  <div class="single-img" v-for="(item, idx) in fileListBefore" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListBefore"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashBackThird"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="uploadWashBack()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washBack')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="removeImg(file, 'washBack')">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="其他材料" prop="washOther" style="position: relative;height: auto">
              <div v-if="washRecorderTitle === '查看'">
                <div class="img-list" v-if="fileListOther">
                  <div class="single-img" v-for="(item, idx) in fileListOther" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListOther"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <div style="position: absolute;left: -100px;top: 30px;width: 100px;">(清洗合同、清洗报告、收据等其他证明材料)(1-5张)</div>
                <el-upload
                  ref="uploadWashOtherThird"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="uploadWashOther()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washOther')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="removeImg(file, 'washOther')">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </div>
          <div v-else-if="ruleForm.washWay === 'Complaint'">
            <el-form-item label="清洗前照片" prop="washPer" style="position: relative;height: auto">
              <div v-if="washRecorderTitle === '查看'">
                <div class="img-list" v-if="fileListInfo">
                  <div class="single-img" v-for="(item, idx) in fileListInfo" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListInfo"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashPerSelf"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="upload()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washPer')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="removeImg(file, 'washPer')">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="清洗后照片" prop="washBack" style="position: relative;height: auto">
              <div v-if="washRecorderTitle === '查看'">
                <div class="img-list" v-if="fileListBefore">
                  <div class="single-img" v-for="(item, idx) in fileListBefore" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListBefore"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashBackSelf"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="uploadWashBack()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washBack')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="removeImg(file, 'washBack')">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </div>
          <div v-else-if="ruleForm.washWay === 'BusinessStopped'">
            <el-form-item label="旧净化器照片" prop="washPer" style="position: relative;height: auto">
              <div v-if="washRecorderTitle === '查看'">
                <div class="img-list" v-if="fileListInfo">
                  <div class="single-img" v-for="(item, idx) in fileListInfo" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListInfo"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashPerFilter"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="upload()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washPer')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="removeImg(file, 'washPer')">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="新净化器照片" prop="washBack" style="position: relative;height: auto">
              <div v-if="washRecorderTitle === '查看'">
                <div class="img-list" v-if="fileListBefore">
                  <div class="single-img" v-for="(item, idx) in fileListBefore" :key="idx"
                       style="position: relative; display: inline-block; margin-right: 10px;">
                    <el-image
                      style="width: 100px;height: 100px"
                      :src="item"
                      fit="fit"
                      :preview-src-list="fileListBefore"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <span style="position: absolute;left: -60px;top: 30px;">(1-5张)</span>
                <el-upload
                  ref="uploadWashBackFilter"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png"
                  :action="uploadWashBack()"
                  :on-success="(res, file) => handleAvatarSuccess(res, file, 'washBack')"
                  :limit="5"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip">（支持jpg、jpeg、png）</div>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="removeImg(file, 'washBack')">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </div>

          <el-form-item label="备注">
            <el-input type="textarea" v-model="ruleForm.remark" placeholder="请备注清洗内容"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="washRecorderTitle !== '查看'" style="text-align: right">
        <span>
          <el-button @click="addWashDialog = false">取 消</el-button>
          <el-button type="primary" @click="addWash">确 定</el-button>
        </span>
      </div>
    </el-dialog>
    <!--    净化器清洗记录新增dialog（结束-->

    <!--净化器清洗台账dialog（开始-->
    <el-dialog
      width="60%"
      :visible.sync="washAccountBook"
      :center="true"
      style="position: fixed !important;
      top: 55%;
      bottom: 50%;
      left: 50%;
      width: 120%;
      height: 120%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translate(-50%, -50%) !important;
      z-index: 999 !important;">
      <div ref="washBookDialog" style="max-height: calc(100vh - 200px);overflow-y: auto;margin-top: -30px">
        <div>
          <h1 style="text-align: center;color: black">油烟净化设备清洗台账</h1>
        </div>
        <el-table
          :data="washBookData.content"
          size="mini"
          border
          highlight-current-row
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="55"
          />
          <el-table-column
            prop="LocaleName"
            label="监测点"
            width="160"
            align="center"
            header-align="center"
          />
          <el-table-column
            prop="CreatedAt"
            label="提交时间"
            width="160"
            align="center"
            show-overflow-tooltip
            header-align="center"
          />
          <el-table-column
            label="清洗日期"
            width="160"
            align="center"
            show-overflow-tooltip
            header-align="center"
          >
            <template slot-scope="{ row }">
              <span>{{ row.EndDate.split(' ')[0] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="清洗方式"
            align="center"
            header-align="center"
            width="160"
          >
            <template slot-scope="{ row }">
              <span>{{ row.UploadType | typeFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="Remark"
            label="备注"
            align="center"
            show-overflow-tooltip
            header-align="center"
          />
          <el-table-column
            label="操作"
            align="center"
            width="100"
            fixed="right"
            header-align="center"
          >
            <template slot-scope="{ row }">
              <el-button type="text" @click="openLookAddWashDialog(row)" size="mini"
              >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="footer" style="text-align:center;">
        <el-button @click="exportWashAccount" type="primary" size="small" :loading="downloading">导出</el-button>
      </div>
    </el-dialog>
    <!--净化器清洗台账dialog（结束-->

    <!--净化器未清洗报警消息记录dialog（开始-->
    <el-dialog width="60%" :visible.sync="FillterNotWash" :center="true" >
      <div style="margin-top: -30px">
        <h1 style="text-align: center;color: black">油烟净化设备未清洗预警消息记录</h1>
      </div>
      <el-table
        :data="NotWashMessage.content"
        size="mini"
        border
        highlight-current-row
      >
        <el-table-column type="index" label="#" align="center" width="55"/>
        <el-table-column
          prop="LocaleName"
          label="监测点"
          width="140"
          show-overflow-tooltip
          header-align="center"
        >
        </el-table-column>
        <el-table-column
          prop="SendAt"
          width="160"
          label="发送时间"
          show-overflow-tooltip
          header-align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ formatDate(row.SendAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="SenderName"
          width="160"
          label="发送人"
          header-align="center"
          align="center"
        />
        <el-table-column
          prop="Content"
          width="auto"
          label="短信内容"
          show-overflow-tooltip
          header-align="center"
          align="center"
        />
      </el-table>
      <div slot="footer" class="footer" style="text-align:center;">
        <el-button @click="sendPoliceMessage" type="primary" size="small" :loading="downloading">发送短息</el-button>
      </div>
    </el-dialog>
    <!--净化器未清洗报警消息记录dialog（结束-->



    <!--净化器未清洗发送短信dialog（开始-->
    <el-dialog
      width="25%"
      :close-on-click-modal="false"
      :visible.sync="visibleOneSend"
    >
      <el-form
        :model="formData"
        label-width="124px"
        ref="formSendOne"
        :rules="formSendOneRule"
        size="mini"
      >
        <el-row>
          <el-form-item
            prop="LocaleName"
            label="监测点名称"
          >
            <el-input
              disabled
              v-model.trim="formData.LocaleName"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            prop="Content"
            label="消息内容"
          >
            <el-input
              type="textarea"
              v-model.trim="formData.Content"
              :autosize="{ minRows: 2, maxRows: 4}"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="visibleOneSend = false"
        >取消
        </el-button>
        <el-button type="primary" size="mini" @click.native="handleSendOne" :loading="loading"
        >发送
        </el-button>
      </div>
    </el-dialog>
    <!--净化器未清洗发送短信dialog（结束-->



    <!--净化器未清洗报警事件记录dialog（开始-->
    <el-dialog
      width="66%"
      :visible.sync="FillterNotWashEvent"
      :center="true"
      style="position: fixed !important;
      top: 50%;
      left: 50%;
      width: 120%;
      height: 120%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translate(-50%, -50%) !important;
      z-index: 999 !important;">
      <div ref="FillterNotWashEvent" style="max-height: calc(100vh - 200px);overflow-y: auto;">
        <div style="margin-top: -28px">
          <h1 style="text-align: center;color: black">清洗管理事件处理记录</h1>
        </div>
        <el-table
          :data="FillterNotWashEventData.list"
          size="mini"
          border
          highlight-current-row
        >
          <el-table-column type="index" label="#" align="center" width="55"/>
          <el-table-column
            prop="locale_name"
            label="监测点"
            width="120"
            show-overflow-tooltip
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="process_at"
            label="报警日期"
            width="100"
            show-overflow-tooltip
            header-align="center"
          />
          <el-table-column
            prop="event_status"
            width="80"
            label="事件状态"
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="process_at"
            width="120"
            label="核实时间"
            show-overflow-tooltip
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="PowerSupplyMode"
            width="80"
            label="核实人员"
            show-overflow-tooltip
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="process_reason"
            width="100"
            label="报警原因"
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="rectify_desc"
            width="80"
            label="整改状态"
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="rectify_message"
            width="auto"
            label="整改详情"
            show-overflow-tooltip
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="handle_at"
            width="120"
            label="执法处理时间"
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="handle_name"
            width="80"
            label="处理人员"
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="solution"
            width="100"
            label="处理结果"
            header-align="center"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
            width="100"
            header-align="center"
          >
            <!--          2025/1/2  整改中和完结状态隐藏掉编辑-->
            <template slot-scope="scope">
              <i
                v-if="scope.row.status !== 3 && scope.row.status !== 1"
                title="处理"
                @click="handleDialogOpen(scope.row, 'edit')"
                class="opt el-icon-edit"
                :style="scope.row.status === 3 && scope.row.status !== 0 ? 'color: #4f4f4f' : 'color: #469afb'"
              />
              <i
                title="查看"
                @click="handleDialogOpen(scope.row, 'view')"
                class="opt el-icon-view"
                style="color: #469afb"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="footer" style="text-align:center;">
        <el-button @click="exportFillterNotWashEvent" type="primary" size="small" :loading="downloading">导出</el-button>
      </div>
    </el-dialog>
    <!--净化器未清洗报警事件记录dialog（结束-->

    <!--  净化器未清洗报警事件记录组件  -->
    <purifier-Wash-View-dialog ref="fillterEventViewDialog" @on-refresh="getData"  />


  </section>
</template>

<script>
import {mapState} from 'vuex'
import {dateFormater, base64ToBlob, ownerJoin} from '@/util/index'
import notificationDialog from '@/component/NotificationDialog'
import LocaleBatchImportDialog from "@/component/LocaleBatchImportDialog.vue";
import {
  getSinglePname,
  getPname,
  getSPname,
  loadData,
  getUserInfo,
  join,
  toIntArray,
  ownerFilter,
} from '@/util/index'
import conf from '@/config'
import LocaleEditDialog from "@/component/LocaleEditDialog.vue";
import StatusChangeDialog from "@/component/locale/StatusChangeDialog.vue";
import OfflineViewDialog from "@/component/offlineManagement/OfflineViewDialog.vue";
import OfflineApplyDialog from "@/component/locale/OfflineApplyDialog.vue";
import purifierWashViewDialog from "@/component/purifierWashView/purifierWashViewDialog.vue";
import _green from '@/asset/img/1.png'
import _yellow from '@/asset/img/5.png'
import _red from '@/asset/img/2.png'
import _redB from '@/asset/img/6.png'
export default {
  name: "purifierWashManage",
  components: {purifierWashViewDialog},
  data() {
    return {
      rectifyAdviceOptions: [
        {value: '更换净化器', label: '更换净化器'},
        {value: '清洗维护净化器', label: '清洗维护净化器'},
        {value: '增设检修，监测平台', label: '增设检修，监测平台'},
      ],
      cascaderOptions: [
        {value: '正常', label: '正常'},
        {value: '数据漂移', label: '数据漂移'},
        {value: '数据偏小', label: '数据偏小'},
        {value: '长时间为0', label: '长时间为0'},
        {value: '数据偏大', label: '数据偏大'},
      ],
      cascaderProps: {
        multiple: true
      },
      addRunVerifyRuleForm:{//新增核查弹窗的表单数据
        LocaleId:'',//监测点
        questionSource: '',//问题来源
        pointType: '',//点位类型
        verifyDay: '',//核查日期
        purifierSituation:'',//净化器工作电流
        cannotDetect:false,//净化器电流无法检测
        purifierStatus:'',//净化器状态
        questionList: [],//问题清单
        otherQuestion:'',//其他问题
        monitorWay:'',//监测仪情况
        monitorDataStatus:'',//监测数据情况
        rectifyAdvice: '',//整改建议
        otherAdvice: '',//其他建议
        sitePic:[],//现场照片
        filterRate: '',
      },
      runVerifyRules:{//新增核查弹窗的规则
        LocaleId: [
          { required: true, message: '请选择监测点', trigger: 'blur' }
        ],
        pointType: [
          { required: true, message: '请选择点位类型', trigger: 'blur' }
        ],
        questionSource: [
          { required: true, message: '请选择问题来源', trigger: 'blur' }
        ],
        purifierStatus: [
          { required: true, message: '请选择净化器状态', trigger: 'blur' }
        ],
        verifyDay: [
          { type: 'string', required: true, message: '请选择核查日期', trigger: 'blur' }
        ],
        monitorWay: [
          { required: true, message: '请选择监测仪情况', trigger: 'change' }
        ],
        purifierSituation: [
          { required: true, message: '请选择净化器状态', trigger: 'change' },{ pattern: /(^-1(.0{1,2})?$)|(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }
        ],
        filterRate: [{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确格式,可保留两位小数' }],
        rectifyAdvice: [
          { required: true, message: '请选择整改建议', trigger: 'change' }
        ],
        sitePic: [
          { required: true, message: '请上传现场照片', trigger: 'change' }
        ]
      },


      addRunVerifyTitle:'',//弹窗的title
      addRunVerify: false,//控制新增/查看运行核查弹窗
      runVerifyParam:{
        owner: null,//所属单位
        MaintainerId:'',//核查人员
        dateRange: null,//核查时间
        currentPage:1,
        PageCurrent:[20,30,50],
        size:20
      },
      isShowRunVerifyRecorder:false,//控制现场核查记录
      filterWashList: [],
      userList:[],


      defaultSort: {prop: "create_at", order: "descending"},//默认的排序
      defaultName:"upload_time",
      CreatDataorder:'descending',//用于控制上次清洗日期排序
      clickNum:0,//用户点击了几次
      order:'desc',//点击上次清洗日期进行排序的（默认降序）
      sendMessageId: {},//存储的发送短信的点位的数据
      washOverDay:'',//存储的当前点位的未清洗天数
      FillterNotWashEventData:[],//未清洗的报警事件记录
      formData: {//存储发送短信的数据
        Id: '',
        Owner: '',
        LocaleName: '',
        Content: ''
      },
      formSendOneRule: {
        Content: [{required: true, message: '内容不可为空', trigger: 'blur'}]
      },
      visibleOneSend:false,//未清洗的短信发送
      NotWashMessage:[],//未清洗的报警消息
      washBookData:[],//清洗台账的数据
      paginationData:{//存储分页数据
        currentPage:1,
        PageCurrent:[20,30,50],
        size:20
      },

      localeList:[],//存储用户输入的监测点名称筛选得到的监测点数据
      fileListInfo: [],//用于查看的时候渲染清洗前的照片（旧净化器）
      fileListBefore: [],//用于查看的时候渲染清洗后的照片（新净化器）
      fileListOther: [],//用于查看的时候渲染清洗其他的材料
      filterWashData:[],//存储净化器清洗上传的数据
      filterWash:{//存储净化器清洗上传筛选的条件
        owner: null,//所属单位
        UpwashWay: '',//清洗方式
        dateRange: null,//清洗时间
      },
      filterWashRecorder:false,//控制清洗记录
      FillterNotWashEvent:false,//控制净化器未清洗报警事件记录
      FillterNotWash:false,//控制净化器未清洗报警消息记录
      downloading:false,
      washAccountBookData:[],//存储净化器清洗台账
      washAccountBook:false,//控制净化器清洗台账记录
      ruleForm: {
        LocaleId:'',//存储用户选择的监测点的Id
        point: '',//存储用户输入的监测点名称
        washWay: '',//存储用户输入的清洗方式
        starDay: new Date(),
        washUnit:'',//存储用户输入的清洗单位
        washPer:[],//存储清洗前照片
        washBack:[],//存储清洗后照片
        washOther:[],//存储清洗的其他材料
        remark:'',//存储用户输入的备注
      },
      rules: {
        LocaleId: [
          { required: true, message: '请选择监测点', trigger: 'blur' }
        ],
        washWay: [
          { required: true, message: '请选择清洗类型', trigger: 'blur' }
        ],
        starDay: [
          { type: 'date', required: true, message: '请选择清洗日期', trigger: 'change' }
        ],
        washUnit: [
          { required: true, message: '请输入清洗单位', trigger: 'blur' },
        ],
        washPer: [
          { required: true, message: '请选择上传清洗前图片', trigger: 'blur' }
        ],
        washBack: [
          { required: true, message: '请选择上传清洗后图片', trigger: 'blur' }
        ],
        washOther: [
          { required: true, message: '请选择上传其他材料', trigger: 'blur' }
        ]
      },
      washRecorderTitle:'',//存储新增净化器弹窗标题
      addWashDialog:false,//净化器新增弹窗控制
      index: 0, // 记录更新index
      sels: [], // 列表选中列
      loading: false,
      datalist: {},//存储渲染的数据
      userInfo: {},
      filter: {
        owner: null,
        dateRange: null,
        filter_wash_day: 30,
        page: 1,
        size: 20,
        pageSizes: [20, 30, 50]
      },
      filterCheck: {
        owner: null,
        user_id: null,
        start_time: null,
        end_time: null,
        page: 1,
        size: 20,
        pageSizes: [20, 30, 50]
      },
      itemKey: 1,
    }
  },
  computed: {
    ...mapState(['areaTree', 'clientHeight', 'locale', 'customerTree']),
    ...mapState({
      props: (state) => Object.assign({}, state.props, {label: 'Org'}),
      customerProps: (state) =>
        Object.assign({}, state.props, {label: 'Org', checkStrictly: true}),
      selAreaProps: (state) =>
        Object.assign({}, state.props, {checkStrictly: true}),
      areaProps: (state) => Object.assign({}, state.props)
    }),
    // 动态计算监测仪情况的label
    monitorLabel() {
      if (this.addRunVerifyRuleForm.pointType === 2) {
        return '监控情况';
      }
      return '监测仪情况';
    },
    // 动态计算监测数据情况的label
    monitorDataLabel() {
      if (this.addRunVerifyRuleForm.pointType === 2) {
        return '监控数据情况';
      }
      return '监测数据情况';
    }
  },
  mounted() {
    // 通过遮罩层关闭图片预览
    document.addEventListener('click',function(e){
      if(e.target.className=="el-image-viewer__mask"){
        let close = document.querySelector(".el-image-viewer__btn");
        close.click();
      }
    })
    try {
      const user = getUserInfo()
      this.userInfo = user.Info
    } catch (e) {
      this.$message.error(e)
    }
    // 更新所属单位（不排除未来需要更新更多数据
    if (!this.customerTree) {
      this.$get('admin/listBasicDataOfCustomer').then(res => {
        this.$store.dispatch('setCustomer', res.Customer)
      })
    }
    if (this.areaTree.length === 0) {
      this.$get('admin/listBasicDataOfArea').then(res => {
        this.$store.dispatch('setArea', res.Area)
      })
    }
    this.getData()
  },
  filters: {
    typeFilter(type) {
      const op = {
        Complaint: '自主清洗',
        FilterWash: '第三方清洗',
        BusinessStopped: '净化器换新'
      }
      return op[type]
    }
  },
  methods: {
    //打开一个点位的油烟净化设备运行情况现场核查记录
    openOnePointRunVerifyRecorder(locale_id){
      const param = {
        page: this.filterCheck.page,
        size: this.filterCheck.size,
        locale_id:locale_id,
      }
      this.$get("admin/filter_check", param).then(res => {
        this.filterWashList = res
        this.isShowRunVerifyRecorder = true
      })
    },
    //选择点位类型
    changePointType(e) {
      if (e === 4) { // 非监测监控类，要关闭监测仪情况必填项
        this.$delete(this.runVerifyRules, 'monitorWay');
      } else {
        // 如果不是非监测监控类，确保验证规则存在
        let message = '请选择监测仪情况';
        if (e === 2) {
          message = '请选择监控情况';
        }
        this.$set(this.runVerifyRules, 'monitorWay', [
          { required: true, message: message, trigger: 'change' }
        ]);
      }
    },
    // 上传现场照片
    uploadSitePic() {
      return conf.uploadApi + '/uploadToOss';
    },
    // 现场照片上传成功
    handleSitePicSuccess(response, file) {
      const url = response.Data;
      const uid = Date.now() + Math.random();
      const name = url.substring(url.lastIndexOf('/') + 1);
      this.addRunVerifyRuleForm.sitePic.push({
        name: name,
        url: url,
        uid: uid
      });
    },
    // 删除现场照片
    handleSitePicRemove(file) {
      const index = this.addRunVerifyRuleForm.sitePic.findIndex(item => item.uid === file.uid);
      if (index !== -1) {
        this.addRunVerifyRuleForm.sitePic.splice(index, 1);
      }
    },
    changeDetect() {
      if(this.addRunVerifyRuleForm.cannotDetect){
        this.addRunVerifyRuleForm.purifierSituation = "-1"
      } else {
        this.addRunVerifyRuleForm.purifierSituation = ""
      }
    },

    //确认新增运行核查记录
    configAddRunVerify(){
       this.$refs.addRunVerifyRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {})
            .then(() => {
              var urls = []
              for(var i = 0; i < this.addRunVerifyRuleForm.sitePic.length; i++) {
                urls.push(this.addRunVerifyRuleForm.sitePic[i].url)
              }
              let params = new URLSearchParams()
              var paramData = {
                "locale_id": this.addRunVerifyRuleForm.LocaleId,
                "source": this.addRunVerifyRuleForm.questionSource,
                "type": this.addRunVerifyRuleForm.pointType,
                "handle_at": this.addRunVerifyRuleForm.verifyDay,
                "pur_current": this.addRunVerifyRuleForm.purifierSituation,
                "is_survey": this.addRunVerifyRuleForm.cannotDetect?1:0,
                "filter_status": this.addRunVerifyRuleForm.purifierStatus,
                "question": this.addRunVerifyRuleForm.questionList.join(","),
                "other": this.addRunVerifyRuleForm.otherQuestion,
                "voc_status": this.addRunVerifyRuleForm.monitorWay,
                "voc_data_status": this.addRunVerifyRuleForm.monitorDataStatus,
                "handle_suggestion": this.addRunVerifyRuleForm.rectifyAdvice.join(","),
                "pics": urls.join(","),
                "other_suggestion": this.addRunVerifyRuleForm.otherAdvice,
              }
              if (this.addRunVerifyRuleForm.filterRate != "") {
                paramData["filter_rate"] = this.addRunVerifyRuleForm.filterRate
              }
              Object.entries(paramData).forEach(([key, val]) => {
                params.append(key, val)
              })
              this.$post('admin/filter_check/add', params)
                .then(() => {
                  this.goSerachRunVerify()
                  this.$message({
                    type: 'success',
                    message: "核实成功"
                  })
                  this.addRunVerify = false
                })
            })
        }
      })
    },
    //打开运行核查记录弹窗
    openAddRunVerify(){
      // 每次打开清空之前输入的全部数据
      this.addRunVerifyRuleForm = {
        LocaleId: '',           // 监测点
        questionSource: '',     // 问题来源
        pointType: '',          // 点位类型
        verifyDay: '',          // 核查日期
        purifierSituation: '',  // 净化器工作电流
        cannotDetect: false,    // 净化器电流无法检测
        purifierStatus: '',     // 净化器状态
        questionList: [],       // 问题清单
        otherQuestion: '',      // 其他问题
        monitorWay: '',         // 监测仪情况
        monitorDataStatus: '',  // 监测数据情况
        rectifyAdvice: [],      // 整改建议
        otherAdvice: '',        // 其他建议
        sitePic: [],             // 现场照片
        filterRate: '',
      }
      // 清除表单验证
      this.$nextTick(() => {
        this.$refs.addRunVerifyRuleForm.clearValidate();
      });
      this.addRunVerifyTitle = '新增'
      this.addRunVerify = true
    },
//查看运行核查记录弹窗
    openLookFilterInfo(row) {
      this.addRunVerifyRuleForm = {
        LocaleName: row.locale_name,
        LocaleId: row.locale_id,           // 监测点
        questionSource: row.source,     // 问题来源
        pointType: row.type,          // 点位类型
        verifyDay: row.handle_at,          // 核查日期
        purifierSituation: row.pur_current,  // 净化器工作电流
        cannotDetect: row.is_survey == 1 ? true: false,    // 净化器电流无法检测
        purifierStatus: row.filter_status,     // 净化器状态
        questionList: row.question.split(","),       // 问题清单
        otherQuestion: row.other,      // 其他问题
        monitorWay: row.voc_status,         // 监测仪情况
        monitorDataStatus: row.voc_data_status,   // 监测数据情况
        rectifyAdvice: row.handle_suggestion.split(","),      // 整改建议
        otherAdvice: row.other_suggestion,        // 其他建议

      }
      if (row.filter_rate >= 0) {
        this.addRunVerifyRuleForm.filterRate = row.filter_rate
      }
      this.fileListInfo = row.pics.split(",")
      this.addRunVerifyTitle = '查看'
      this.addRunVerify = true
    },
    //打开运行核查记录弹窗
    async runVerifyRecorder(){
      this.filterWashList = {}
      this.filterCheck = {
        owner: null,
        user_id: null,
        start_time: null,
        end_time: null,
        page: 1,
        size: 20,
        pageSizes: [20, 30, 50]
      }
      await this.goSerachRunVerify()
      this.isShowRunVerifyRecorder = true
    },

    remoteFilterMethod(queryString) {
      if (queryString !== '') {
        setTimeout(() => {
          const par = {"StartAt":0,"Size":100,"Param":{"Name":queryString}}
          this.$post('admin/listCaUser', par).then((res) => {
            this.userList = res.content
          }).catch(() => {})
        }, 300);
      } else {
        this.userList = [];
      }
    },

    deleteWashFilterInfo(row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('admin/filter_check/delete/' + row.id)
          .then(() => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.goSerachRunVerify()
          })
      })
    },
    ExportSerachRunVerify(){
      this.$prompt(`请输入导出的数据量（总量：${this.filterWashList.count} 条）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '只能填入数字'
      }).then(({value}) => {
        const loading = this.$loading({
          lock: true,
          text: '数据加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 1000);
        const param = {
          page: 1,
          size: parseInt(value),
          is_download: 1,
        }
        if (this.filterCheck.owner && this.filterCheck.owner.length > 0) {
          param.owner = `${ownerJoin(this.filterCheck.owner, this.userInfo)}`
        }
        if (this.filterCheck.user_id != null && this.filterCheck.user_id.length > 0) {
          param.user_id = this.filterCheck.user_id
        }
        if(this.filterCheck.dateRange  && this.filterCheck.dateRange.length > 0){
          param.start_time = this.filterCheck.dateRange[0]
          param.end_time = this.filterCheck.dateRange[1]
        }
        this.$get("admin/filter_check", param).then(res => {
          let url = res.url
          const link = document.createElement('a')
          link.setAttribute('href', url)
          link.click()
          setTimeout(() => {
            loading.close();
          }, 1000);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    },

    handleFilterCheckSizeChange(size) {
      this.filterCheck.size = size
      this.goSerachRunVerify()
    },
    // 翻页
    handleFilterCheckCurrentChange(page) {
      this.filterCheck.page = page
      this.goSerachRunVerify()
    },

    goSerachRunVerify(){
      this.filterWashList = {}
      const param = {
        page: this.filterCheck.page,
        size: this.filterCheck.size,
      }
      if (this.filterCheck.owner && this.filterCheck.owner.length > 0) {
        param.owner = `${ownerJoin(this.filterCheck.owner, this.userInfo)}`
      }
      if (this.filterCheck.user_id != null && this.filterCheck.user_id.length > 0) {
        param.user_id = this.filterCheck.user_id
      }
      if(this.filterCheck.dateRange  && this.filterCheck.dateRange.length > 0){
        param.start_time = this.filterCheck.dateRange[0]
        param.end_time = this.filterCheck.dateRange[1]
      }
      this.$get("admin/filter_check", param).then(res => {
        this.filterWashList = res
      })
    },

    formatDate(timestamp) {
      const date = new Date(timestamp * 1000); // 时间戳需要乘以1000
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    handleSortChange({ column, prop, order }) {
      // 定义字段映射
      const fieldMap = {
        create_at: "upload_time",
        stove_num: "stove_num",
        filter_wash_day: "filter_wash_day",
        un_wash_day: "un_wash_day",
        wash_over_day: "wash_over_day",
        wash_number: "wash_number",
        status: "status"
      };
      // 校验
      if (!fieldMap[prop]) {
        console.warn(`未知的排序字段: ${prop}`);
        return;
      }
      // 更新排序状态
      this.order = order === 'ascending' ? 'asc' : 'desc';
      // 设置 defaultName
      this.defaultName = fieldMap[prop];
      // 设置 defaultSort
      if (order === 'ascending' || order === 'descending') {
        this.defaultSort = { prop, order };
      } else {
        // 处理非法排序，默认降序
        this.defaultSort = { prop, order: 'descending' };
      }
      this.CreatDataorder = order;
      // 获取数据
      this.getData();
    },
    canSelectRow(row, index) {
      return row.color !== '绿色';
    },
    //清洗上传分页组件
    handlePageChange(val, field) {
      if(field === 'PageCurrent'){//当前页数
        this.paginationData.currentPage = val
      }
      if(field === 'Size'){//当前每页数量
        this.paginationData.size = val
      }
      const para = {
        page:this.paginationData.currentPage,
        perPage:this.paginationData.size,
        IsFilterImage: 1,
      }
      if(this.filterWash.dateRange  && this.filterWash.dateRange.length > 0){
        para.RecordAtStart = this.filterWash.dateRange[0]
        para.RecordAtEnd = this.filterWash.dateRange[1]
      }
      if (this.filterWash.owner && this.filterWash.owner.length !== 0) {
        const owner = `${ownerJoin(this.filterWash.owner, this.userInfo)}`
        para.Owner = owner
        // para.Owner= join(this.filterWash.owner)
      }
      if (this.filterWash.UpwashWay && this.filterWash.UpwashWay !== '') {
        para.UpwashWay= this.filterWash.UpwashWay
      }
      this.$post('admin/queryLocaleUploadedInfo',para).then(res => {
        this.filterWashData = res
      })
    },
    //导出清洗上传的记录
    ExportWashRecorder(){
      this.$prompt(`请输入导出的数据量（总量：${this.filterWashData.total} 条）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '只能填入数字'
      }).then(({value}) => {
        const loading = this.$loading({
          lock: true,
          text: '数据加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const para = {
          Page:1,
          // PerPage:20,
          PerPage:parseInt(value),
          IsDownload:1,
          IsFilterImage: 1,
        }
        if(this.filterWash.dateRange  && this.filterWash.dateRange.length > 0){
          para.RecordAtStart = this.filterWash.dateRange[0]
          para.RecordAtEnd = this.filterWash.dateRange[1]
        }
        if (this.filterWash.owner && this.filterWash.owner.length !== 0) {
          const owner = `${ownerJoin(this.filterWash.owner, this.userInfo)}`
          para.Owner = owner
          // para.Owner= join(this.filterWash.owner)
        }
        if (this.filterWash.UpwashWay && this.filterWash.UpwashWay !== '') {
          para.UpwashWay= this.filterWash.UpwashWay
        }
        this.$post('admin/queryLocaleUploadedInfo',para).then(res => {
          let url = res.url
          const link = document.createElement('a')
          link.setAttribute('href', url)
          link.click()
          // 关闭加载框
          loading.close()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    },
    //查看用户新增的净化器清洗
    openLookAddWashDialog(row){
      this.washRecorderTitle = '查看';
      this.addWashDialog = true;

      this.fileListInfo = row.LocaleUploadedInfoBeforePicS//清洗前的照片（旧净化器）
      this.fileListBefore = row.LocaleUploadedInfoPicS,//用于查看的时候渲染清洗后的照片（新净化器）
      this.fileListOther = row.LocaleUploadedInfoOtherPicS,//用于查看的时候渲染清洗其他的材料
      this.ruleForm.starDay = row.EndDate.split(' ')[0]//清洗日期
      this.ruleForm.washUnit = row.WashName//清洗单位
      this.ruleForm.washWay = row.UploadType//清洗方式
      this.ruleForm.remark = row.Remark//清洗备注
      this.ruleForm.point = row.LocaleName//点位名称
    },
    //输入监测点名称请求的数据
    remoteMethod(queryString) {
      if (queryString !== '') {
        setTimeout(() => {
          const par = {"StartAt":0,"Size":100,"Param":{"Name":queryString}}
          this.$post('admin/listLocale', par).then((res) => {
            this.localeList = res.content
          }).catch(() => {})
        }, 300);
      } else {
        this.localeList = [];
      }
    },
    //新增净化器清洗记录
    openAddWash(row){
      // 如果是从外面点击的清洗上传则手动赋值，也可以根据弹窗布尔值判断
      if(row !== ''){
        this.ruleForm.LocaleId = row.id,//直接拿到当前点位的Id
        this.ruleForm.point = row.name
      }
      this.washRecorderTitle = '新增';
      this.addWashDialog = true;
      // 清空表单数据
      this.resetRuleForm(row);
    },
    //查询净化器上传的记录
    goSerachWash(){
      this.paginationData.currentPage = 1
      //请求删选条件的数据
      this.getAccountInfo()
    },
    // 新增方法：处理筛选条件变化
    handleFilterChange() {
      // 筛选条件变化时，重置页码到第一页
      this.filter.page = 1;
      this.getData();
    },
    //刚进入页面默认请求的数据
    getData() {
      this.loading = true
      const param = {
        page: this.filter.page,
        size: this.filter.size,
        is_download: false
      }
      if (this.filter.owner && this.filter.owner.length > 0) {
        const owner = `${ownerJoin(this.filter.owner, this.userInfo)}`
        param.owner = owner
      }
      if (this.filter.status !== "" && this.filter.status !== null) {
        param.status = this.filter.status
      }
      if (this.filter.filter_wash_day) {
        param.filter_wash_day = this.filter.filter_wash_day
      }
      if (this.filter.dateRange) {
        param.start_at = this.filter.dateRange[0].getTime() / 1000
        param.end_at = this.filter.dateRange[1].getTime() / 1000
      }
      if (this.order) {
        param.filter = this.order
      }
      if(this.defaultName){
        param.name = this.defaultName
      }
      this.$get("admin/LocaleWashList", param).then(res => {
        this.datalist.content = res.list
        this.datalist.total = res.count
        this.itemKey = Math.random()
        this.loading = false
      })
    },
    openExportSizeInput() {
      this.$prompt(`请输入导出的数据量（总量：${this.datalist.total} 条）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '只能填入数字'
      }).then(({value}) => {
        this.handleExport(parseInt(value))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    },
    handleExport(num) {
      const loading = this.$loading({
        lock: true,
        text: '数据导出中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const param = {
        page: this.filter.page,
        // size: this.filter.size,
        size: num,
        is_download: true
      }
      if (this.filter.owner && this.filter.owner.length > 0) {
        const owner = `${ownerJoin(this.filter.owner, this.userInfo)}`
        param.owner = owner
      }
      if (this.filter.status !== "" && this.filter.status !== null) {
        param.status = this.filter.status
      }
      if (this.filter.filter_wash_day) {
        param.filter_wash_day = this.filter.filter_wash_day
      }
      if (this.filter.dateRange) {
        param.start_at = this.filter.dateRange[0].getTime() / 1000
        param.end_at = this.filter.dateRange[1].getTime() / 1000
      }
      this.$get("admin/LocaleWashList", param).then(res => {
        let url = res.url
        const link = document.createElement('a')
        link.setAttribute('href', url)
        link.click()
        setTimeout(() => {
          loading.close();
        }, 1000);
      })
    },


    getPname(r, c) {
      return getPname(this.customerTree, r[c.property], 'Org').join('/')
    },

    //打开净化器清洗报警事件里的查看/编辑页面
    handleDialogOpen(row, mode) {
      this.$refs['fillterEventViewDialog'].dealDialog(mode, row)
    },
    //导出净化器清洗报警事件处理记录
    exportFillterNotWashEvent(){
      this.downloading = true
      this.$prompt(`请输入导出的数据量（总量：${this.FillterNotWashEventData.count} 条）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '只能填入数字'
      }).then(({value}) => {
        //定义加载中的动画
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          target: document.querySelector(".submit-dialog") // .submit-dialog 指的是 el-dialog 的 class
        });
        const param = {
          locale_id:this.FillterNotWashEventData.list[0].locale_id,
          size: parseInt(value),
          is_download: true,
          typ: 4,
        }
        this.$get("admin/alarmManagement/list", param).then(res => {
          let url = res.url
          const link = document.createElement('a')
          link.setAttribute('href', url)
          link.click()
        })
        loading.close();
        this.downloading = false
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
        this.downloading = false
      })
    },
    //发送净化器未清洗报警消息记录
    sendPoliceMessage(){

      // if(this.NotWashMessage.content[0]){//当这个点位有过发送信息的时候则打开这个dialog，不然报错
      //   this.formData = this.NotWashMessage.content[0]
      //   const currentDate = new Date();
      //   const formattedDate = currentDate.toISOString().split('T')[0];
      //   this.formData.Content = '【' + `${this.NotWashMessage.content[0].LocaleName}` + '】,' + '截止【'+ formattedDate + '】您已' + `${this.washOverDay}` + '天未进行净化器清洗，请及时清洗并上传清洗记录。'
      //   this.visibleOneSend = true
      // }
      this.formData.LocaleName = this.sendMessageId.name
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split('T')[0];
      this.formData.Content = '【' + `${this.sendMessageId.name}` + '】,' + '截止【'+ formattedDate + '】您已' + `${this.washOverDay}` + '天未进行净化器清洗，请及时清洗并上传清洗记录。'
      this.visibleOneSend = true
    },
    //执行发送一条短信
    handleSendOne() {
      this.$refs.formSendOne.validate((valid) => {
        if (valid) {
          this.$confirm('确认发送短信吗？', '提示')
            .then(() => {
              //定义加载中的动画
              const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                target: document.querySelector(".submit-dialog") // .submit-dialog 指的是 el-dialog 的 class
              });
              const ids = this.sendMessageId.id
              let param = new FormData()
              param.append("ids",ids)
              this.$post('admin/sendWashMessage', param)
                .then((res) => {
                  this.$message.success(res)
                  this.visibleOneSend = false
                  loading.close();
                })
                .catch(() => {
                })
            })
        }
      })
    },
    //导出净化器清洗台账
    exportWashAccount(){
      this.downloading = true
      this.$prompt(`请输入导出的数据量（总量：${this.washBookData.total} 条）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '只能填入数字'
      }).then(({value}) => {
        const loading = this.$loading({
          lock: true,
          text: '数据加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const param = {
          LocaleId: this.washBookData.content[0].LocaleId,
          page: 1,
          size: parseInt(value),
          IsDownload: 1,
        }
        this.$post("admin/queryLocaleUploadedInfo", param).then(res => {
          let url = res.url
          const link = document.createElement('a')
          link.setAttribute('href', url)
          link.click()
          loading.close();
        })
        this.downloading = false
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
        this.downloading = false
      })
    },
    handleClose() {

      this.$emit('on-close', false)
    },
    //时间转换方法
    dateFormat(r, c) {
      return dateFormater(r[c.property], true)
    },

    //净化器清洗报警事件处理记录
    openPoliceEvent(row){
      // console.log('row',row)
      const para = {
        typ: 4,
        locale_id:row.id,
      }
      this.$get("admin/alarmManagement/list", para).then(res => {
        this.FillterNotWashEventData = res
      })
      this.FillterNotWashEvent = true
    },
    //净化器未清洗报警消息记录
    openFillterNotWash(row){
      this.sendMessageId = {}
      this.sendMessageId = row
      this.washOverDay = row.un_wash_day//拿到当前点位的超时多少天未清洗
      const para ={
        Param:{
          locale_id:{
            S:0,
            V:`'${row.id}'`
          }
        }
      }
      this.$post('admin/listMessage',para).then(res => {
        this.NotWashMessage = res

      })
      this.FillterNotWash = true
    },
    //净化器清洗台账
    openWashAccountBook(row) {
      const para ={
        LocaleId:row.id
      }
      this.$post('admin/queryLocaleUploadedInfo',para).then(res => {
        this.washBookData = res

      })
      this.washAccountBook = true
    },

    selsChange: function (sels) {
      this.sels = sels
    },
    // 改变页容量
    handleSizeChange(size) {
      this.filter.size = size
      this.getData()
    },
    // 翻页
    handleCurrentChange(page) {
      this.filter.page = page
      this.getData()
    },

    deleteWashInfo(row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('admin/LocaleUploadedInfo/delete/' + row.Id)
          .then(() => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getAccountInfo()
          })
      })
    },


    //请求的商家信息上传的接口
    getAccountInfo(){
      const para = {
        page:this.paginationData.currentPage,
        perPage:this.paginationData.size,
        IsFilterImage:1
      }
      if(this.filterWash.dateRange  && this.filterWash.dateRange.length > 0){
        para.RecordAtStart = this.filterWash.dateRange[0]
        para.RecordAtEnd = this.filterWash.dateRange[1]
      }
      if (this.filterWash.owner && this.filterWash.owner.length !== 0) {
        const  owner = `${ownerJoin(this.filterWash.owner, this.userInfo)}`
        para.Owner = owner
      }
      if (this.filterWash.UpwashWay && this.filterWash.UpwashWay !== '') {
        para.UploadType= this.filterWash.UpwashWay
      }
      this.$post('admin/queryLocaleUploadedInfo',para).then(res => {
        this.filterWashData = res
      })
    },
    //打开新增弹窗清洗记录上传的弹窗
    washRecorder() {
      this.filterWash = {}//每次打开清空之前选择的条件
      //在这里请求商家信息上传的数据接口（目前没有店名更改和其他，所以接口直接不传参数）
      this.getAccountInfo()

      this.filterWashRecorder = true

    },
    //用户确认提交数据
    addWash() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.ruleForm.starDay = new Date().toISOString().split('T')[0]
          const para = {
            WashName:this.ruleForm.washUnit,//清洗单位
            EndDate:this.ruleForm.starDay,//清洗时间
            Id:0,//id 0代表的是新增 有记录的则不是0
            LocaleId:this.ruleForm.LocaleId,
            LocaleUploadedInfoBeforePicS:this.ruleForm.washPer,//清洗前照片washPer
            LocaleUploadedInfoOtherPicS:this.ruleForm.washOther,//其他材料washBack
            LocaleUploadedInfoPicS:this.ruleForm.washBack,//清洗后照片washOther
            Status:2,//提交
            UploadType:this.ruleForm.washWay,//清洗方式
            remark: this.ruleForm.remark,//备注
          }
          this.$post('admin/createLocaleUploadedInfo', para)
            .then(() => {
              this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.getAccountInfo()
              this.addWashDialog = false;
            })
            .catch(() => {})

        }
      });
    },
    //改变清洗方式
    changeWashWay(value) {
      // 清空相应的字段
      this.ruleForm.washPer = [];
      this.ruleForm.washBack = [];
      this.ruleForm.washOther = [];

      // 重置上传组件状态
      this.clearUpload('uploadWashPerThird');
      this.clearUpload('uploadWashBackThird');
      this.clearUpload('uploadWashOtherThird');

      this.clearUpload('uploadWashPerSelf');
      this.clearUpload('uploadWashBackSelf');

      this.clearUpload('uploadWashPerFilter');
      this.clearUpload('uploadWashBackFilter');

      // 如果选择了第三方清洗，则添加清洗单位的验证规则
      if (value === 'FilterWash') {
        this.$set(this.rules, 'washUnit', [{ required: true, message: '请输入清洗单位', trigger: 'blur' }]);
      } else {
        this.$delete(this.rules, 'washUnit');
      }
    },
    getImg(status) {
      switch (status) {
        case '绿色':// 1
          return _green
        case '黄色':// 2
          return _yellow
        case '红色':// 3
          return _red
        case '红黑色':// 4
          return _redB
        default:
          return _green
      }
    },
    validateWashUnit(rule, value, callback) {
      if (!value && this.ruleForm.washWay === '1') {
        callback(new Error('请输入清洗单位'));
      } else {
        callback();
      }
    },
    //上传清洗前照片
    upload() {
      return conf.uploadApi + '/uploadToOss';
    },
    //上传清洗后照片
    uploadWashBack() {
      return conf.uploadApi + '/uploadToOss';
    },
    //上传清洗其他照片
    uploadWashOther() {
      return conf.uploadApi + '/uploadToOss';
    },
    //图片上传完成时调用
    handleAvatarSuccess(res, file, field) {
      this.ruleForm[field].push( res.Data);
    },
    //移除上传的图片
    removeImg(file, field) {
      const uploadRef = this.$refs[`upload${field.charAt(0).toUpperCase() + field.slice(1)}Third`] ||
        this.$refs[`upload${field.charAt(0).toUpperCase() + field.slice(1)}Self`] ||
        this.$refs[`upload${field.charAt(0).toUpperCase() + field.slice(1)}Filter`];
      if (uploadRef) {
        let uploadFile = uploadRef.uploadFiles;
        let index = uploadFile.indexOf(file);
        uploadFile.splice(index, 1);
        this.ruleForm[field].splice(index, 1);
      }
    },
    //清除上传图片的状态
    clearUpload(refName) {
      const uploadRef = this.$refs[refName];
      if (uploadRef) {
        uploadRef.clearFiles();
      }
    },
    //重置输入的数据
    resetRuleForm(row) {
      // 如果是从清洗记录里面上传清空点位的名称和Id
      if(row === ''){
        this.ruleForm.point = '';
        this.ruleForm.LocaleId = '';
      }
      this.ruleForm.washWay = '';
      this.ruleForm.starDay = new Date(); // 重新设置默认日期
      this.ruleForm.washUnit = '';
      this.ruleForm.washPer = [];
      this.ruleForm.washBack = [];
      this.ruleForm.washOther = [];
      this.ruleForm.remark = '';

      // 移除清洗单位的验证规则
      this.$delete(this.rules, 'washUnit');

      // 重置上传组件状态
      this.clearUpload('uploadWashPerThird');
      this.clearUpload('uploadWashBackThird');
      this.clearUpload('uploadWashOtherThird');

      this.clearUpload('uploadWashPerSelf');
      this.clearUpload('uploadWashBackSelf');

      this.clearUpload('uploadWashPerFilter');
      this.clearUpload('uploadWashBackFilter');
    },
    // 批量发送短信
    batchSendMessage: function () {
      const ids = this.sels.map((item) => item.id).toString()
      this.$confirm('确认给选中的记录发送短信吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          //定义加载中的动画
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            target: document.querySelector(".submit-dialog") // .submit-dialog 指的是 el-dialog 的 class
          });
          let param = new FormData()
          param.append("ids",ids)
          this.$post('admin/sendWashMessage', param)
            .then((res) => {
              this.$message.success(res)
              this.visibleOneSend = false
              loading.close()
            })
            .catch(() => {
            })
        })
        .catch(() => {
        })
    },


  }
}
</script>

<style lang="scss" scoped>


.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}

.single-img > img {
  width: 80px;
  height: 80px;
}

.view-img {
  width: 178px;
  height: 178px;
  margin-right: 10px;
}

.remove-img {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  color: #FFF;
  text-align: center;
  background: rgba(0, 0, 0, .5);
  transition: transform .3s;
  -webkit-transition: transform .3s;
}

.remove-img:hover {
  cursor: pointer;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}


.locale-tool {
  .el-select--mini ::v-deep .el-input--suffix {
    width: 120px;
  }
}

.form-part {
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
  border-width: 1px;
  border-style: solid;
  border-radius: 10px;
  border-color: #eeeeee;
}
/deep/ .el-form-item__label {
  padding: 0px 5px 0px 0px !important;
}
/deep/  .el-image-viewer__prev {
  left: 340px !important;
}
/deep/  .el-image-viewer__next {
  right: 340px !important;
}
/deep/  .el-image-viewer__close {
  top: 149px !important;
  right: 200px !important;
  background-color: #ECF4FB;
}
/deep/ .el-image-viewer__img  {
  margin-top: 2.5% !important;
  max-height: 83% !important;;
  max-width: 80% !important;
}
</style>
